import { Fallback, Image, Root } from "@radix-ui/react-avatar";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type AvatarProps = ComponentProps<typeof Root>;
type AvatarImageProps = ComponentProps<typeof Image>;
type AvatarFallbackProps = ComponentProps<typeof Fallback>;

export const Avatar: FC<AvatarProps> = ({ className, ...props }) => (
  <Root
    data-slot="avatar"
    className={cn(
      "relative flex size-8 shrink-0 overflow-hidden rounded-full",
      className,
    )}
    {...props}
  />
);

export const AvatarImage: FC<AvatarImageProps> = ({ className, ...props }) => (
  <Image
    data-slot="avatar-image"
    className={cn("aspect-square size-full", className)}
    {...props}
  />
);

export const AvatarFallback: FC<AvatarFallbackProps> = ({
  className,
  ...props
}) => (
  <Fallback
    data-slot="avatar-fallback"
    className={cn(
      "bg-muted flex size-full items-center justify-center rounded-full",
      className,
    )}
    {...props}
  />
);
